import { render, staticRenderFns } from "./PolicyAcceptance.vue?vue&type=template&id=98ccc64c&scoped=true&"
import script from "./PolicyAcceptance.vue?vue&type=script&lang=ts&"
export * from "./PolicyAcceptance.vue?vue&type=script&lang=ts&"
import style0 from "./PolicyAcceptance.vue?vue&type=style&index=0&id=98ccc64c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ccc64c",
  null
  
)

export default component.exports